import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CloseLarge, CloseSmall } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useXStyles } from '@pets-ui/useXStyles/useXStyles'
import * as stylex from '@stylexjs/stylex'

const _baseStyles = stylex.create({
  root: {
    padding: '16px',
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  titleContainer: {
    width: '100%',
  },
  closeButton: {
    color: colors.grey600,
    position: 'absolute',
    right: 12,
    top: 10,
  },
  backgroundHidden: {
    borderColor: colors.white,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    color: colors.white,
  },
})

interface PopupHeaderProps {
  title?: string
  backgroundHidden: boolean
  onClose?: () => void
}

export const PopupHeader = (props: PopupHeaderProps) => {
  const { title, onClose, backgroundHidden } = props
  const baseStyles = useXStyles(_baseStyles)

  return (
    <HStack pb={4} height="38px" alignItems="center">
      {title && (
        <div {...stylex.props(baseStyles.titleContainer)}>
          <Text variant="h5" align="center" color={backgroundHidden ? colors.white : colors.grey900}>{title}</Text>
        </div>
      )}
      <IconButton
        fontSize="24px"
        rootStyle={[baseStyles.closeButton, backgroundHidden && baseStyles.backgroundHidden]}
        onClick={onClose}
        data-testid="popup-close-button"
      >
        {backgroundHidden ? <CloseSmall /> : <CloseLarge />}
      </IconButton>
    </HStack>
  )
}
